module.exports = __webpack_public_path__ + "img/DeliveryRecord.709f91cf.png";